export default "__VITE_ASSET__Dvz9NfcD__"